export default {
  data () {
    return {
      messageStatusOptions: [
        { status: '-', color: '', icon: ''},
        { status: 'Information', color: 'success', icon: 'CheckCircleIcon'},
        { status: 'Alerte', color: 'danger', icon: 'AlertOctagonIcon'},
        { status: 'Action réalisée', color: 'info', icon: 'CalendarIcon'},
        { status: 'Demande d’action', color: 'primary', icon: 'MailIcon'}
        // { status: 'Rendez-vous', color: 'info', icon: 'CalendarIcon'}
      ]
    }
  }
}

/*
- Information
- Alerte
- Action réalisée
- Demande d’action


MessageSquareIcon, PackageIcon, AlertOctagonIcon, MailIcon, CalendarIcon
*/